import { Action, ActionType } from "app/pages/AgentSearch/actionTypes";
import { AgentSearchStatus } from "app/pages/AgentSearch/modules/AgentItemsList/state";
import { AgentSearchResult } from "app/shared/model";

export function pageLoaded(searchTerm: string, agents: AgentSearchResult[]) : Action { 
    return {
        type: ActionType.PageLoaded,
        searchTerm: searchTerm, 
        agents: agents
    };
}

export function changeSearchTerm(searchTerm: string) : Action {
    return {
        type: ActionType.ChangeSearchTerm,
        searchTerm: searchTerm
    }
}

export function changeSearchStatus(status: AgentSearchStatus) : Action {
    return {
        type: ActionType.ChangeSearchStatus,
        status: status
    }
}

export function agentSearchResult(agents: AgentSearchResult[]) : Action {
    return {
        type: ActionType.AgentSearchResult, 
        agents: agents
    }
} 